import type { TurbineViewRenderProps } from "./TurbineViewRender.tsx";
import { Descriptions } from "antd";
import { Card } from "../../../common/components/Card.tsx";
import { makeMapButton } from "./MapButton.tsx";

export const TurbineInfo = (props: TurbineViewRenderProps) => {
	const { intl, turbineData } = props;
	const { turbine } = turbineData;

	return (
		<Card title={intl.formatMessage({ id: "detailed_information" })}>
			<Descriptions bordered column={2}>
				<Descriptions.Item
					label={intl.formatMessage({
						id: "turbine_table_column_serial_number",
					})}
				>
					{turbine.serial_number}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({
						id: "turbine_table_column_park_number",
					})}
				>
					{turbine.park_number ?? "—"}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_table_column_client" })}
				>
					{turbine.client.legal_name}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_table_column_location" })}
				>
					{turbine.location.name}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_table_column_latitude" })}
				>
					{turbine.latitude}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_table_column_longitude" })}
				>
					{turbine.longitude}
				</Descriptions.Item>
				<Descriptions.Item label={intl.formatMessage({ id: "turbine_map" })}>
					{turbine.latitude != null && turbine.longitude != null
						? makeMapButton(
								turbine.latitude.toString(),
								turbine.longitude.toString(),
							)
						: null}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_manufacturer" })}
				>
					{turbine.manufacturer ?? "—"}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_service_lift" })}
				>
					{turbine.service_lift ?? "—"}
				</Descriptions.Item>
				<Descriptions.Item
					label={intl.formatMessage({ id: "turbine_fall_protection_system" })}
				>
					{turbine.fall_protection_system ?? "—"}
				</Descriptions.Item>
			</Descriptions>
		</Card>
	);
};
